export enum FacetType {
    DEFAULT = "default",
    NUMERIC = "numeric",
    COLORSWATCH = "colorswatch",
    UNIT_RANGE = "unit-range",
    HIERARCHICAL = "hierarchical",
}

export type DefaultFacetValue = Record<string, number>;

export type NumericFacetValue = {
    min: number;
    max: number;
};

export type ColorswatchFacetValue = {
    name: string;
    url: string;
    value: string;
};

export type UnitRangeFacetValue = {
    unit: string;
    upperBound: number;
    lowerBound: number;
    value: string;
    nbHits: number;
};

export type RecursiveHierarchicalFacet = {
    count: number;
    facetValue: string;
    childValues: Record<string, RecursiveHierarchicalFacet>;
};
export type HierarchicalFacetValue =
    | Record<string, number>
    | Record<string, RecursiveHierarchicalFacet>;

export type FacetTypeToValueMap = {
    [FacetType.DEFAULT]: DefaultFacetValue;
    [FacetType.NUMERIC]: NumericFacetValue;
    [FacetType.COLORSWATCH]: Array<ColorswatchFacetValue>;
    [FacetType.UNIT_RANGE]: Array<UnitRangeFacetValue>;
    [FacetType.HIERARCHICAL]: HierarchicalFacetValue;
};
